import { GET_EXHIBITOR_ENTRY_PASS_DETAILS, SUBMIT_EXHIBITOR_ENTRY_PASS } from "../../../utils/constants";


const initialState = [];

function exhibitorEntryPass_reducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GET_EXHIBITOR_ENTRY_PASS_DETAILS:
            return [...state, payload];
        case SUBMIT_EXHIBITOR_ENTRY_PASS:
            return [...state, payload];
        default:
            return state;
    }
};

export default exhibitorEntryPass_reducer;